// import {getDecodedToken, getValidToken} from "../../utility/axios-token-manager/token"

const initialState = {
  userProfile: null,
  agentMerchant: [],
  agents: [],
  merchants: [],
  feedbacks: [],
  merchant: {},
  makeFeedBack: false,
  success: false,
  message: '',
  // ext admin state
  extAdminDashboard: null,
  extAdminProfile: null,
  extAdminAgents: [],
  extAdminFeedbacks: [],
  extAdminMerchants: [],
  extAdminPayments: [],
  extAdminCommission: 0,
  // global admin state (ext-admin scope)
  globalDashboard: null,
  globalAgents: [],
  globalAgentDetail: null,
  globalMerchants: [],
  globalSalesAdmins: [],
  globalWallets: [],
  globalFeedbacks: [],
  // super admin state (EXMANAF — whole-app scope)
  superDashboard: null,
  superAgents: [],
  superAgentDetail: null,
  superMerchants: [],
  superSalesAdmins: [],
  superSalesAdminDetail: null,
  superWallets: [],
  superFeedbacks: [],
  superSectors: [],
  // ext-admin sectors
  extSectors: [],
  // admin payments & paystack
  adminPaymentsOverview: null,
  adminTransactions: [],
  adminTransactionsMeta: {},
  adminTxDetail: null,
  adminSettlements: [],
  adminSettlementsMeta: {},
  adminDisputes: [],
  adminDisputesMeta: {},
  adminRefunds: [],
  adminRefundsMeta: {},
  adminWalletDetail: null,
  // admin seerbit wallets & compliance
  seerbitWallets: [],
  seerbitWalletDetail: null,
  tierUpgradeRequests: [],
  businessUpgradeRequests: [],
  // admin subscription plans
  adminSubPlans: [],
  adminMerchantSubs: [],
  adminMerchantSubsMeta: {},
  adminSubPayments: [],
  adminSubPaymentsMeta: {},
  // platform earnings
  adminEarnings: null,
  // admin payout management
  adminPayouts: [],
  adminPayoutsMeta: {},
  adminAgentPayoutDetail: null,
  // agent-facing commission/payout
  agentCommissionBalance: null,
  agentPayouts: [],
}
const setProfile = (state, data) => {
  return {
    ...state, userProfile: data.profile, agentMerchant: data.merchants
  }
};
const setAll = (state, data) => {
  return {
    ...state, agents: data.agents, feedbacks: data.feedbacks
  }
};

const merchantsAll = (state, data) => {
  return {
    ...state, merchants: data.merchants, message: data.message, success: data.success
  }
};

const merchant = (state, data) => {
  return {
    ...state, merchant: data.merchant
  }
};



const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PROFILE":
      return setProfile(state, action.payload);
    case "SET_ALL":
      return setAll(state, action.payload);
    case "MERCH_ALL":
      return merchantsAll(state, action.payload);
    case "MERCHANT":
      return merchant(state, action.payload);
    case "SET_UPDATE":
      return { ...state, agents: action.payload };
    case "MAKE_FEEDBACK":
      return { ...state, makeFeedBack: action.payload };
    case "EXT_ADMIN_DASHBOARD":
      return { ...state, extAdminDashboard: action.payload };
    case "EXT_ADMIN_AGENTS":
      return { ...state, extAdminAgents: action.payload.agents, extAdminFeedbacks: action.payload.feedbacks };
    case "EXT_ADMIN_MERCHANTS":
      return { ...state, extAdminMerchants: action.payload.merchants, extAdminPayments: action.payload.payments, extAdminCommission: action.payload.totalCommission };
    case "EXT_ADMIN_FEEDBACKS":
      return { ...state, extAdminFeedbacks: action.payload };
    case "EXT_ADMIN_PROFILE":
      return { ...state, extAdminProfile: action.payload };
    case "GLOBAL_DASHBOARD":
      return { ...state, globalDashboard: action.payload };
    case "GLOBAL_AGENTS":
      return { ...state, globalAgents: action.payload };
    case "GLOBAL_AGENT_DETAIL":
      return { ...state, globalAgentDetail: action.payload };
    case "GLOBAL_MERCHANTS":
      return { ...state, globalMerchants: action.payload };
    case "GLOBAL_SALES_ADMINS":
      return { ...state, globalSalesAdmins: action.payload };
    case "GLOBAL_WALLETS":
      return { ...state, globalWallets: action.payload };
    case "GLOBAL_FEEDBACKS":
      return { ...state, globalFeedbacks: action.payload };
    case "SUPER_DASHBOARD":
      return { ...state, superDashboard: action.payload };
    case "SUPER_AGENTS":
      return { ...state, superAgents: action.payload };
    case "SUPER_AGENT_DETAIL":
      return { ...state, superAgentDetail: action.payload };
    case "SUPER_MERCHANTS":
      return { ...state, superMerchants: action.payload };
    case "SUPER_SALES_ADMINS":
      return { ...state, superSalesAdmins: action.payload };
    case "SUPER_SALES_ADMIN_DETAIL":
      return { ...state, superSalesAdminDetail: action.payload };
    case "SUPER_WALLETS":
      return { ...state, superWallets: action.payload };
    case "SUPER_FEEDBACKS":
      return { ...state, superFeedbacks: action.payload };
    case "SUPER_SECTORS":
      return { ...state, superSectors: action.payload };
    case "EXT_SECTORS":
      return { ...state, extSectors: action.payload };
    case "ADMIN_PAYMENTS_OVERVIEW":
      return { ...state, adminPaymentsOverview: action.payload };
    case "ADMIN_TRANSACTIONS":
      return { ...state, adminTransactions: action.payload.data, adminTransactionsMeta: action.payload.meta };
    case "ADMIN_TX_DETAIL":
      return { ...state, adminTxDetail: action.payload };
    case "ADMIN_SETTLEMENTS":
      return { ...state, adminSettlements: action.payload.data, adminSettlementsMeta: action.payload.meta };
    case "ADMIN_DISPUTES":
      return { ...state, adminDisputes: action.payload.data, adminDisputesMeta: action.payload.meta };
    case "ADMIN_REFUNDS":
      return { ...state, adminRefunds: action.payload.data, adminRefundsMeta: action.payload.meta };
    case "ADMIN_WALLET_DETAIL":
      return { ...state, adminWalletDetail: action.payload };
    case "SEERBIT_WALLETS":
      return { ...state, seerbitWallets: action.payload };
    case "SEERBIT_WALLET_DETAIL":
      return { ...state, seerbitWalletDetail: action.payload };
    case "TIER_UPGRADE_REQUESTS":
      return { ...state, tierUpgradeRequests: action.payload };
    case "BUSINESS_UPGRADE_REQUESTS":
      return { ...state, businessUpgradeRequests: action.payload };
    case "POS_REQUESTS":
      return { ...state, posRequests: action.payload };
    case "ADMIN_SUB_PLANS":
      return { ...state, adminSubPlans: action.payload };
    case "ADMIN_MERCHANT_SUBS":
      return { ...state, adminMerchantSubs: action.payload.data, adminMerchantSubsMeta: action.payload.meta };
    case "ADMIN_SUB_PAYMENTS":
      return { ...state, adminSubPayments: action.payload.data, adminSubPaymentsMeta: action.payload.meta };
    case "ADMIN_EARNINGS":
      return { ...state, adminEarnings: action.payload };
    case "ADMIN_PAYOUTS":
      return { ...state, adminPayouts: action.payload.data, adminPayoutsMeta: action.payload.meta };
    case "ADMIN_AGENT_PAYOUT_DETAIL":
      return { ...state, adminAgentPayoutDetail: action.payload };
    case "AGENT_COMMISSION_BALANCE":
      return { ...state, agentCommissionBalance: action.payload };
    case "AGENT_PAYOUTS":
      return { ...state, agentPayouts: action.payload };
    default:
      return state;
  }
};

export default authReducer;